<template>
  <div class="home">
    <template v-if="!getAppStatus.disableScanners">
      <div class="row home-row">
        <div class="col-lg-6 mt-3">
          <portlet
              :icon="'fad fa-truck-loading'"
              :title="$t('shopfloor.loading')"
              class="mb-3"
          >
            <template slot="portletBody">
              <router-link to="loading" tag="button" class="w-100 d-block btn btn-primary">
                {{$t('shopfloor.homePage.startLoading')}}
              </router-link>
            </template>
          </portlet>
        </div>

        <div class="col-lg-6 mt-3">
          <portlet
              :icon="'fad fa-truck-ramp'"
              :title="$t('shopfloor.unloading')"
          >
            <template slot="portletBody">
              <router-link to="unloading" tag="button" class="w-100 d-block btn btn-primary">
                {{$t('shopfloor.homePage.startUnloading')}}
              </router-link>
            </template>
          </portlet>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="cycle-count-blocked">
        <portlet
            :icon="'fad fa-abacus'"
            :title="$t('shopfloor.cyclecount.blockedTitle')"
            class="mb-3"
        >
          <template slot="portletBody">
            {{ $t('shopfloor.cyclecount.blockedMessage') }}
          </template>
        </portlet>
      </div>
    </template>
    <router-view></router-view>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: 'home',
    components: {},
    computed: {
      ...mapGetters('appstatus', [
        'getAppStatus'
      ])
    }
  }
</script>

<style lang="scss" scoped>
.cycle-count-blocked {
  padding: 1rem;
}
</style>